<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Privacy Policy - Plug P2P</title>
  <style>
    html, body {
      margin: 0;
      padding: 0;
      min-height: 100vh;
      font-family: 'Poppins', sans-serif;
      display: flex;
      flex-direction: column;
    }

    header {
      background-color: #000;
      color: white;
      text-align: center;
      padding: 15px 10px;
    }

    main {
      padding: 20px;
      max-width: 800px;
      margin: auto;
      flex: 1;
    }

    h1 {
      font-size: 24px;
      margin: 0;
    }

    h2 {
      font-size: 23px;
      margin-top: 20px;
      margin-bottom: 10px;
      color: black;
    }


    h3 {
      font-size: 20px;
      margin-top: 20px;
      margin-bottom: 10px;
      color: black;
    }


    h4 {
      font-size: 18px;
      margin-top: 20px;
      margin-bottom: 10px;
      color: black;
    }

    p {
      font-size: 16px;
      line-height: 1.6;
      margin-bottom: 16px;
      color: grey;
    }

    footer {
      background-color: #000;
      color: white;
      text-align: center;
      padding: 15px 10px;
      width: 100%;
    }

    @media (max-width: 600px) {
      h1 {
        font-size: 20px;
      }

      h2 {
        font-size: 18px;
      }

      p {
        font-size: 15px;
      }

      header, footer {
        font-size: 14px;
      }
    }
  </style>
</head>
<body>


  <main>
    <h2>Privacy <span style="color: #F87C56;">Policy</span></h2>

    <p style="color: black;">Last Updated: April 21, 2025</p>

    <p>
      Welcome to Plug P2P, a peer-to-peer platform for electric vehicle (EV) charging. Your privacy is of great importance to Plug P2P, Inc. (“Plug P2P”, “we”, “us”, the “company”, or “our”). This Privacy Policy is incorporated into our
      <a href="https://admin.plugp2p.com/terms-conditions/Redirection" style=" color: blue; text-decoration: underline;">Terms and Conditions of Service</a>.
      We collect, use and disclose personally identifiable information about you (or “User”) through the Platform (“Personal Information”). This Privacy Policy is designed to inform you of how we collect, use, share and protect your personal data and information. Capitalized terms are as defined in the Terms and Conditions of Service.
    </p>
    
    <p>You acknowledge and agree that you are solely responsible for the form, content, and accuracy of any Personal Information that you submit, upload, or otherwise post on or through the Platform. You also agree that your Personal Information may be available to other Users and our third-party service providers in accordance with this Privacy Policy.</p>

    <p style="font-weight: bold;color: black;">By providing your Personal Information, you expressly consent to the use of your Personal Information for purposes relating to the Platform, including the processing, storage, transfer and retention of your Personal Information as required to fulfill the disclosed purposes or to comply with legal requirements. By providing us with your phone number and email, you give us express permission to contact you via call, text, notification and via email.</p>

    <h2>1. Information We Collect</h2>

    <p > <span style="color: black;">a. Personal Information:</span><br>
     When you register for an account on Plug P2P, we collect personal information such as your name, email address, and contact number. If you are a Charge Host, we may also collect information about your EV charging device(s), including electrical characteristics, images, location, availability, and cost.</p>

    <p><span style="color: black;">b. Payment Information:</span><br>
    To process transactions, we collect payment information, which may include credit card numbers or other payment method details and/or bank account information. Payment processing is handled by our secure third-party payment processors, including, without limitation, Stripe, Inc. Plug P2P does not store your credit card information.</p>

    <p><span style="color: black;">c. Usage Data and Device Information:</span><br>
    We collect information about how you interact with our Platform, including usage frequency, the pages you view, and other actions on or relating to the Platform. We also collect data from your device, including IP address, operating system, browser type, and mobile network information, in order to improve your user experience. When you visit the Platform, we may send one or more “cookies” to your computer, mobile device, or other device. A “cookie” is a small data file transferred by a website or mobile app to your computer hard drive or device central processing unit. We use cookies to help improve the Platform and to personalize your visit by customizing our mobile app screens or web pages. Most browsers will accept cookies automatically from the Platform. You may refuse to accept cookies by adjusting your preferences on your browser, however, by doing so, you may be unable to access certain pages or areas of the Platform.</p>


<p>We have collected the following categories of Personal Information from within the last twelve (12) months:</p>

<table style="width:100%; border-collapse: collapse; font-size: 16px;" border="1">
  <thead style="background-color: #f2f2f2;">
    <tr>
      <th style="padding: 8px;">CATEGORY</th>
      <th style="padding: 8px;">EXAMPLES</th>
      <th style="padding: 8px;">COLLECTED</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style="padding: 8px;color: grey;">1. Identifiers</td>
      <td style="padding: 8px;color: grey;">Name, alias, postal address, unique personal identifier, online identifier, Internet Protocol (IP) address, email address, account name, or other similar identifiers.</td>
      <td style="padding: 8px;color: grey; text-align: center;">YES</td>
    </tr>
    <tr>
      <td style="padding: 8px;color: grey;">2. Customer Records Information</td>
      <td style="padding: 8px;color: grey;">Name, signature, address, telephone number, passport number, credit or debit card number, bank account information. Some personal information included in this category may overlap with other categories.</td>
      <td style="padding: 8px; text-align: center;color: grey;">YES</td>
    </tr>
    <tr>
      <td style="padding: 8px;color: grey;">3. Commercial Information</td>
      <td style="padding: 8px;color: grey;">Records of services purchased, obtained or considered, or other purchasing or consuming histories or tendencies.</td>
      <td style="padding: 8px;color: grey; text-align: center;">YES</td>
    </tr>
    <tr>
      <td style="padding: 8px;color: grey;">4. Internet or other electronic network activity information</td>
      <td style="padding: 8px;color: grey;">IP address, information on a user’s interaction with a website or application.</td>
      <td style="padding: 8px;color: grey; text-align: center;">YES</td>
    </tr>
    <tr>
      <td style="padding: 8px;color: grey;">5. Geolocation data</td>
      <td style="padding: 8px;color: grey;">Physical location or movements.</td>
      <td style="padding: 8px; color: grey;text-align: center;">YES</td>
    </tr>
  </tbody>
</table>


<h2>2. How We Use Information</h2>
<p style="color: black;">The information we collect is used in the following ways:</p>
<div style="margin-left: 25px;">


<ul style="font-size: 16px; line-height: 1.6; padding-left: 20px;">
  <p style="color: grey;">a. To provide our services, including, without limitation, facilitating communications and scheduling, reservations, and payments for EV charging device reservations as well as ratings and reviews.</p>
  <p style="color: grey;">b. To improve our business and our services and the promotional materials we have developed to describe those services.</p>
  <p style="color: grey;">c. To consider and address feedback you may provide to us.</p>
  <p style="color: grey;">d. To personalize your experience and create tailored content or offers that may be of interest to you.</p>
  <p style="color: grey;">e. To communicate with you, including sending updates, support messages, and promotional information related to Plug P2P.</p>
  <p style="color: grey;">f. To protect the integrity of and ensure the security of our Platform, prevent fraud, and enforce our Terms and Conditions.</p>
</ul>
</div>

<h2>3. How We Share Information</h2>
<p>Personal Information may be shared with third parties in the following circumstances:</p>

<div style="margin-left: 25px;">

<h3>a. Consent</h3>
<p>We may share information with your consent or at your direction, such as when you choose to share details about an EV charging device with other Users or to facilitate communications or allowing the posting of ratings and reviews.</p>

<h3>b. Service Providers</h3>
<p>We may share information with third-party service providers who perform services on our behalf, such as payment processing, data analysis, and email delivery.</p>

<h3>c. Legal Obligations</h3>
<p>We may disclose information if required by law or in response to a lawful request by public authorities, including to meet mandatory national security or law enforcement requirements.</p>

<h3>d. Sale</h3>
<p>We may include Personal Information in a sale or transfer of all or a portion of our business or assets.</p>

</div>

<h3>4) How Long We Keep Your Information</h3>
<p>We will only keep your personal information for as long as it is necessary, generally two (2) years, for the purposes set out in this policy, unless a longer retention period is required or permitted by law (such as tax, accounting or other financial or legal requirements).</p>

<p>When we have no ongoing legitimate business or legal need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information until deletion is possible.</p>

<h3>5) How We Secure Information</h3>
<p>We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. We implement security practices and procedures designed to protect the confidentiality and integrity of your data, including encryption and secure server hosting.</p>

<p>We do not intentionally collect Personal Information from children under the age of 14. If you are aware that we have inadvertently collected any such information, please contact us as set forth below and we will delete the information.</p>

<p>Our third-party service providers have their own data security practices over which we have no control or responsibility.</p>

<h3>6) Changes to This Policy</h3>
<p>Plug P2P reserves the right to update or change our Privacy Policy at any time. We will notify you of any significant changes by posting the new Privacy Policy on our app and updating the effective date at the top of this policy.</p>

<h3>7) How to Contact Us</h3>
<p>If you have any questions about this Privacy Policy or our data practices, or wish to update your information, please contact us at: <a href="mailto:email@plugp2p.com" style="text-decoration: underline;">email@plugp2p.com</a></p>

<h3>8) Your Rights and Choices (California Residents only)</h3>

<p>The CCPA provides California residents with specific rights regarding their Personal Information. This section describes your CCPA rights and explains how to exercise those rights.</p>

<h4>a. Access to Specific Information and Data Portability Rights</h4>
<p>You have the right to request that we disclose certain information to you about our collection and use of your Personal Information over the past 12 months. Once we receive and confirm your verifiable candidate request, we will disclose to you:</p>

<ul>
  <p style="color: grey;">i.The categories of Personal Information we collected about you.</p>
  <p style="color: grey;">ii.The categories of sources for the Personal Information we collected about you.</p>
  <p style="color: grey;">iii.Our business or commercial purpose for collecting or selling that Personal Information.</p>
  <p style="color: grey;">iv.The categories of third parties with whom we share that Personal Information.</p>
  <p style="color: grey;">v.The specific pieces of Personal Information we collected about you (also called a data portability request).</p>
  <p style="color: grey;">vi.If we sold or disclosed your Personal Information for a business purpose, two separate lists disclosing Sales, identifying the Personal Information categories that each category of recipient purchased; and Disclosures for a business purpose, identifying the Personal Information categories that each category of recipient obtained.</p>
</ul>

<h4>b. Deletion Request Rights</h4>
<p>You have the right to request that we delete any of your Personal Information that we collected from you and retained, subject to certain exceptions. Once we receive and confirm your verifiable data subject request, we will delete (and direct our service providers to delete) your Personal Information from our records, unless an exception or good faith, commercially reasonable business justification applies.</p>

<p>We may deny your deletion request if retaining the information is necessary for us or our service providers to:</p>

<ul>
  <p style="color: grey;">i.Complete the transaction for which we collected the Personal Information, provide a good or service that you requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, or otherwise perform our contract with you.</p>
  <p style="color: grey;">ii.Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities.</p>
  <p style="color: grey;">iii.Debug products to identify and repair errors that impair existing intended functionality.</p>
  <p style="color: grey;">iv.Exercise free speech, ensure the right of another data subject to exercise their free speech rights, or exercise another right provided for by law.</p>
  <p style="color: grey;">v.Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 seq.).</p>
  <p style="color: grey;">vi.Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when the information's deletion may likely render impossible or seriously impair the research's achievement, if you previously provided informed consent.</p>


<p style="color: grey;">vii.Enable solely internal uses that are reasonably aligned with candidate expectations based on your relationship with us.</p>

  <p style="color: grey;">viii.Comply with a present or potential legal obligation.</p>
  <p style="color: grey;">ix.Make other internal and lawful uses of that information that are compatible with the context in which you provided it.</p>
</ul>

<h4>c. Non-Discrimination</h4>
<p>We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not:</p>
<ul>
  <p style="color: grey;">i.Deny you goods or services.</p>
  <p style="color: grey;">ii.Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties.</p>
  <p style="color: grey;">iii.Provide you a different level or quality of goods or services.</p>
  <p style="color: grey;">iv.Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services.</p>
</ul>

<h4>d. Accessing and Correcting Your Information</h4>
<p>We endeavor to maintain accurate information and provide you with options to update your information. You can contact <a href="mailto:email@plugp2p.com" style="text-decoration: underline;">email@plugp2p.com</a> and modify your information at any time.</p>



  </main>

 
</body>
</html>
